import Axios from "../config/axios-v1-config";

// ─── Proposals ────────────────────────────────────────────────────────────────

export const getCompanyProposals = (companyId) =>
  Axios.get(`logistics-companies/${companyId}/proposals`);

export const updateProposal = (proposalId, data) =>
  Axios.patch(`proposals/${proposalId}`, data);

// ─── Logistics Company ────────────────────────────────────────────────────────

export const getLogisticsCompany = (id) =>
  Axios.get(`logistics-companies/${id}`);

// Catálogo de operadores ({_id, name}) de todos los países. SOLO para el
// superadmin del sistema: cualquier otro rol recibe 403 del backend. Alimenta
// el selector "Operador" de /admin/pedidos.
export const getPlatformLogisticsCompanies = () =>
  Axios.get(`logistics-companies`);

// Estado de las integraciones e-commerce del operador (LogisticCompany.integrations[]),
// sanitizadas en el backend (sin tokens). El operador se resuelve desde la sesión
// (no se pasa id). La ruta vive en microservice-integrations (dominio de integraciones)
// y el bff la proxya. Devuelve [{ integrationName, alias, userId, linkedOn, ... }].
export const getOperatorIntegrations = () => Axios.get(`integrations/operator`);

export const updateLogisticsCompany = (id, data) =>
  Axios.patch(`logistics-companies/${id}`, data);

// Sube el logo de la empresa logística. Envía dos archivos:
//   - logo: imagen original (PNG/JPG/WEBP) para visualización.
//   - zpl:  PNG ya normalizado (≤320×120) para convertir a ZPL en el backend.
// El backend sube el original a B2, convierte a ^GFA vía Labelary y persiste
// { logo, zplLogo } en la empresa. Devuelve { logo, zplLogo }.
export const uploadLogisticsCompanyLogo = (id, { logoFile, zplBlob }) => {
  const fd = new FormData();
  fd.append("logo", logoFile, logoFile.name || "logo.png");
  fd.append("zpl", zplBlob, "logo-zpl.png");
  return Axios.patch(`logistics-companies/${id}/logo`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// ─── Delivery config (por operador: logística o comercio con flota propia) ──────
// El backend resuelve el operador dueño desde el JWT; no se envía ownerId.

export const getDeliveryConfig = () =>
  Axios.get("configuration/delivery");

export const updateDeliveryConfig = (data) =>
  Axios.patch("configuration/delivery", data);

// ─── Política para quitar pedidos de la ruta ──────────────────────────────────
// Vive en microservice-packages (el BFF solo la proxya). El operador sale del
// JWT. Responde { mode, radiusMeters, isDefault, geocodedCount, warehouses[],
// updatedAt }; el PATCH recibe { mode, radiusMeters? } y responde lo mismo.

export const getRouteRemovalPolicy = () =>
  Axios.get("packages/route-removal-policy");

export const updateRouteRemovalPolicy = (data) =>
  Axios.patch("packages/route-removal-policy", data);

// ─── Geo ──────────────────────────────────────────────────────────────────────

// Catálogo geográfico del BFF (Mongo directo; las claves son ObjectIds, que es
// lo que guarda `coverageAreas`). `countryId` es opcional: sin él el backend
// responde Chile, igual que antes de la expansión a Argentina.
export const getRegions = (countryId) =>
  Axios.get(countryId ? `regiones.json?countryId=${encodeURIComponent(countryId)}` : "regiones.json");

export const getCommunesByRegion = (regionId) =>
  Axios.get(`comunas_by_region.json?region_id=${regionId}`);

// Cobertura disponible del COMERCIANTE autenticado (operador(es) que lo atienden y sus
// comunas cubiertas). companyId se deriva del JWT en el backend. Devuelve
// { ok, operators:[{_id,name}], coverage:[{ regionId, full, communeIds }] }.
export const getMyCoverage = () => Axios.get("contracts/my-coverage");

// Capacidades que el operador habilita para el COMERCIO autenticado. Existe porque el
// comercio no puede leer la config del operador (configuration/delivery y
// billing/cod-config son admin-only): el BFF agrega y expone solo lo que el comercio
// necesita saber. companyId se deriva del JWT, nunca se manda por parámetro.
// Devuelve { cashOnDelivery: { enabled, methods[], currency } | null }, donde null
// significa "no se pudo determinar" y se trata igual que deshabilitado (fail-closed).
export const getCommerceCapabilities = () =>
  Axios.get("configuration/commerce-capabilities");
